export const iconFontAwesomeBuildingsHouseChimney = (
	<i className="fa-solid fa-house-chimney"></i>
);
